var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "order-form" },
    [
      !_vm.orderId
        ? _c("content-creator", {
            staticClass: "header-carousel",
            attrs: {
              settings: _vm.getBlobContents("somnambulist-banner"),
              permissions: _vm.contentCreatorPermissions,
              "is-visible": _vm.editContentCreator,
              filestore: _vm.websitefilestore,
              "allowed-widgets": "carousel,vimeo-video",
              name: "bannerBlob",
            },
            on: {
              updateBlob: (payload) =>
                _vm.saveBlob("somnambulist-banner", payload),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.orderId
        ? _c("div", { staticClass: "intro-step-container" }, [
            _c(
              "div",
              { staticClass: "container intro-step" },
              [
                _c("content-creator", {
                  attrs: {
                    settings: _vm.getBlobContents("somnambulist-intro"),
                    permissions: _vm.contentCreatorPermissions,
                    "is-visible": _vm.editContentCreator,
                    filestore: _vm.websitefilestore,
                    "allowed-widgets":
                      "grid, link-list, advanced-wysiwyg-editor, wysiwyg-editor, carousel, content-list, content-grid, vimeo-video",
                    name: "introBlob",
                  },
                  on: {
                    updateBlob: (payload) =>
                      _vm.saveBlob("somnambulist-intro", payload),
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasData
        ? [
            _vm.showFull
              ? [
                  _c("step", {
                    attrs: {
                      "step-number": 1,
                      "header-lang-string-id": "orderTypeStep",
                      "step-component": "order-type-step",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { attrs: { name: "fade" } },
                    [
                      _vm.getCurrentStep > 1
                        ? _c("step", {
                            attrs: {
                              "step-number": 2,
                              "header-lang-string-id": "frequencyStep",
                              "step-component": "frequency-step",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { attrs: { name: "fade" } },
                    [
                      _vm.getCurrentStep > 2
                        ? _c("step", {
                            attrs: {
                              "step-number": 3,
                              "header-lang-string-id": "quantityStep",
                              "step-component": "quantity-step",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "transition",
              { attrs: { name: "fade" } },
              [
                _vm.getCurrentStep > 3 && _vm.isCustomOrder
                  ? _c("step", {
                      attrs: {
                        "step-number": 4,
                        "header-lang-string-id": "customStep",
                        "step-component": "custom-step",
                      },
                      on: {
                        modalToggled: function ($event) {
                          _vm.productModalActive = !_vm.productModalActive
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _c("div", { staticClass: "no-clubs" }, [
            _vm._v(
              "\n    No clubs were found. This could either be because there are no clubs setup or that they failed to load.\n  "
            ),
          ]),
      _vm._v(" "),
      _c("stepper", {
        attrs: { lowerzindex: _vm.productModalActive },
        on: {
          completed: function ($event) {
            return _vm.setCompleted()
          },
          changed: function ($event) {
            return _vm.$emit("changed")
          },
        },
      }),
      _vm._v(" "),
      _vm.groupExistsObject
        ? _c(
            "AModal",
            {
              attrs: { "disable-portaling": "" },
              model: {
                value: _vm.groupExistsModalVisible,
                callback: function ($$v) {
                  _vm.groupExistsModalVisible = $$v
                },
                expression: "groupExistsModalVisible",
              },
            },
            [
              _c("div", { staticClass: "already-exists" }, [
                _c(
                  "div",
                  { staticClass: "icon" },
                  [_c("MembershipExistsIcon")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "h3",
                  { staticClass: "title" },
                  [
                    _vm.groupExistsObject.multiple
                      ? [
                          _vm._v(
                            "\n          You have multiple active memberships of this type.\n        "
                          ),
                        ]
                      : [
                          _vm._v(
                            "\n          You have an active membership of this type.\n        "
                          ),
                        ],
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "lead" },
                  [
                    _vm.groupExistsObject.multiple
                      ? [
                          _vm._v("\n          You can "),
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  _vm.groupExistsModalVisible = false
                                },
                              },
                            },
                            [_vm._v("continue")]
                          ),
                          _vm._v(
                            " with your order, however a new one will be created.\n          Alternatively, you could "
                          ),
                          _c(
                            "generic-link",
                            {
                              attrs: { href: `/user/${_vm.userId}/membership` },
                            },
                            [
                              _vm._v(
                                "\n            visit your member portal\n          "
                              ),
                            ]
                          ),
                          _vm._v(
                            " and update your current memberships.\n        "
                          ),
                        ]
                      : [
                          _vm._v("\n          You can "),
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  _vm.groupExistsModalVisible = false
                                },
                              },
                            },
                            [_vm._v("continue")]
                          ),
                          _vm._v(
                            " with your order, however a new one will be created.\n          Alternatively, you could "
                          ),
                          _c(
                            "generic-link",
                            {
                              attrs: {
                                href: `/wine-club/edit/${_vm.groupExistsObject.orderId}`,
                              },
                            },
                            [_vm._v("\n            edit\n          ")]
                          ),
                          _vm._v(" your existing membership.\n        "),
                        ],
                  ],
                  2
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modalVisible
        ? _c(
            "a-modal",
            {
              attrs: { "disable-portaling": "", "enable-close": false },
              model: {
                value: _vm.modalVisible,
                callback: function ($$v) {
                  _vm.modalVisible = $$v
                },
                expression: "modalVisible",
              },
            },
            [
              _c("div", { staticClass: "login-account-section" }, [
                _c("h3", { staticClass: "login-account-lead" }, [
                  _vm._v(
                    "\n        Log in or Create a New Account to continue"
                  ),
                  _c("br"),
                  _vm._v("\n        your Wine Club Registration."),
                  _c("br"),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.changeOrder.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n          Click here\n        ")]
                  ),
                  _vm._v("\n        to change your selection"),
                  _c("br"),
                ]),
              ]),
              _vm._v(" "),
              _c("login-subform", {
                attrs: { "show-create-account": true },
                on: { loginInProgress: _vm.loginInProgress },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }